/* eslint-disable max-classes-per-file */
import EntitiesList from 'aurelio/src/abstracts/entitiesList';

export class ProductFeedsProductsList extends EntitiesList {
  constructor(appAPI, accountId) {
    super();

    this._appAPI = appAPI;
    this._accountId = accountId;
    this._setPaginationAsList();
  }
  loadProducts() {
    return this._loadFirstPage();
  }
  moveToTheNextPage() {
    return this._moveTheListToTheNextPage();
  }
  moveToThePreviousPage() {
    return this._moveTheListToThePreviousPage();
  }
  _formatResponse(response) {
    return {
      entities: response.products,
      total: response.pagination.total,
    };
  }
  _getProducts() {
    return this._appAPI.getProductFeedsProducts(
      this._accountId,
      this.currentPage,
      this.searchQuery,
      this.itemsPerPage,
      this.sortBy,
      this.sortAsc ? 'asc' : 'desc',
    );
  }
  _makeFirstPageRequest() {
    return this._getProducts();
  }
  _makeNextPageRequest() {
    return this._getProducts();
  }
}

export class ProductFeedsProductsListManager {
  constructor(appAPI) {
    'inject';

    this._appAPI = appAPI;
  }
  newList(accountId) {
    return new ProductFeedsProductsList(this._appAPI, accountId);
  }
}
